// AgendaPro's Intercom workspace id (`app.id_code`). Not a secret — it is
// embedded in the public Messenger snippet. Conversations created by the
// Intercom webhook use the Intercom conversation id as `threadId`, so the
// inbox deep link can be built straight from it.
export const INTERCOM_WORKSPACE_ID = 'ulkusyjq';

export const INTERCOM_CHANNEL = 'intercom';

export const intercomConversationUrl = (conversationId: string): string =>
	`https://app.intercom.com/a/inbox/${INTERCOM_WORKSPACE_ID}/inbox/conversation/${conversationId}`;
